
import { Component, Vue, Prop } from "vue-property-decorator";
import { ITypeModel, IUserModel } from "@/api/types";
import { cal } from "@/utils/cal";
import { DraftModel } from "./types";
import Pagination from "@/components/Pagination/index.vue";
import ModifyDiscounts from "./components/ModifyDiscounts.vue";
import ModifyRate from "./components/ModifyRate.vue";
import History from "./components/History.vue";
import { ShippingOrderModel } from "@/model/shipping-order";
import { COMPANY_OPTIONS, QUOTED_STATUS } from "@/constant";
import {
  getDraftList,
  getDraftStatus,
  getNumberTypes,
  getSuppliersList,
  getDraftPriceType,
  removeInquirySheetPIProduct,
  removeRecordsProduct,
  changeDraftSupplier,
  changeQuotationSupplier,
  saveInquirySheet,
  submitDraft,
  getConversionExchangeRate,
  updateDraftDiscount,
  updateRecordsDiscount,
  updateDraftQuantity,
  updateInquirySheetQuantity,
  updateDraftUnitPrice,
  updateRecordsUnitPrice,
  updateDraftDiscountAndProfit,
  updateRecordsProfit,
  getEditSearch,
  copyQuotation,
  uploadPiDraft,
  downloadDraft,
  downloadQuotation,
  uploadInquiryApprovalRecord,
  putDraftPriceType, updateDetailBrandName, updateInquirySheetBrandName,
} from "@/api/inquiry";
import { truncate } from "fs/promises";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";
import { deepClone } from "@/utils/deepClone";
import {UserModule} from "@/store/modules/user";
import {findBrandByKeyword} from "@/api/brand";
import { calcQuantityStep } from "@/utils/number";


@Component({
  name: "proformaInvoiceDraft",
  components: {
    Pagination,
    ModifyDiscounts,
    History,
    ModifyRate,
  },
})
export default class extends Vue {
  @Prop({ default: false }) private isEdit: boolean;
  // 是否显示所有产品号码
  private isShowMore = false;
  private isShowMore2 = false;
  private isShowMore3 = false;
  private isShowMore4 = false;
  private showModify = false;
  private showHistory = false;
  private saveSubmitLoading = false;
  private showRate = false;
  private tableKey = 0;
  private conversionExchangeRate = 0;
  private approvalRecordId = "";
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  private draftStatus = [];
  private companyCodeOptions = COMPANY_OPTIONS;
  private containerTypeOptionsList: ITypeModel[] = [];
  public shippingOrder: DraftModel[] = [];
  private sellerList: IUserModel[] = [];
  private actionName = {
    create: "新增",
    createContainerType: "新增柜型",
    editContainerType: "编辑柜型",
    confirmPutShipping: "确认放舱",
  };

  private JobPositionType = {
    seller: "seller",
    purchaser: "purchaser",
    logisticsClerk: "logistics-clerk",
  };
  private cascadeProps = {
    multiple: true,
    emitPath: false,
    value: "id",
    label: "name",
  };
  private total = 0;
  private listLoading = true;
  private selectedRow: ShippingOrderModel = new ShippingOrderModel();

  //对话框的一个状态
  private dialogStatus = "";
  private dialogFormVisible = false;
  private containerTypeVisible = false;
  private confirmPutShippingVisible = false;
  private isExporting = false;
  private downloadPIDraft = false;
  private allUpdate = false;
  private allUpdateEdit = false;
  private allUpdateEditNo = false;
  private downloadHQcomp = false;
  private saveBaoJiaLoading = false;

  private selectedItem = {} as DraftModel;
  private inquirySheetId = "";

  configuredContainerTypes = [{ id: null, name: null, value: null }];
  private listParam = {
    inquirySheetId: null,
    refNumber: null,
    refTypeId: null,
    quotedStatus: null,
    orderStatus: null,
    supplier: null,
    hqProductName: null,
    type: null,
    code: null,
    customerId: null,
  };
  public searchForm = [
    {
      label: "产品型号",
      prop: "refNumber",
      key: "refNumber",
      type: "input",
      value: "",
      placeholder: "请输入产品型号",
    },
    {
      label: "搜索类型",
      prop: "refTypeId",
      key: "refTypeId",
      type: "select",
      value: "",
      placeholder: "全部",
      options: [],
      // resetKey: { label: "desc", value: "name" },
    },
    {
      label: "当前询报价单号",
      prop: "code",
      key: "code",
      type: "input",
      value: "",
      value1: "",
      placeholder: "当前询报价单号",
      readonly: true,
      no_reset: true,
    },
    {
      label: "结果筛选",
      prop: "quotedStatus",
      key: "quotedStatus",
      type: "select",
      value: "",
      placeholder: "全部",
      options: QUOTED_STATUS,
    },
    {
      label: "供应商",
      prop: "supplier",
      key: "supplier",
      type: "select",
      value: "",
      placeholder: "",
      remote_method: this.getSuppliersList,
      remote: true,
      clearable: true,
      options: [],
      resetKey: { label: "abbreviation", value: "id" },
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      type: "input",
      value: "",
      placeholder: "请输入华强品名",
    },
    {
      label: "单价类型",
      prop: "type",
      key: "type",
      type: "select",
      value: "",
      placeholder: "全部",
      options: [],
      // resetKey: { label: "desc", value: "name" },
    },
  ];
  public tableCol = [
    {
      label: "S/N",
      prop: "sn",
      key: "sn",
      show: true,
      fixed: true,
      disabled: false,
    },
    {
      label: "供应商选择偏好",
      prop: "selectSupplierCriteria",
      key: "selectSupplierCriteria",
      show: true,
      disabled: false,
    },
    {
      label: "询价参照号",
      prop: "inquiryReferenceNumber",
      key: "inquiryReferenceNumber",
      show: true,
      disabled: false,
    },
    {
      label: "询价参照号类型",
      prop: "inquiryReferenceNumberType",
      key: "inquiryReferenceNumberType",
      show: true,
      disabled: false,
    },
    {
      label: "品牌名称",
      prop: "brandName",
      key: "brandName",
      show: true,
      disabled: false,
      type: "select",
      width: 140,
      remote_method: this.getTableBrand,
      remote: true,
      filterable: true,
      options: [],
      resetKey: { label: "name", value: "id" },
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false,
    },
    {
      label: "PRODUCT NAME",
      prop: "productName",
      key: "productName",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "DESCRIPTION1",
      prop: "description1",
      key: "description1",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "产品属性1",
      prop: "productAttributes1",
      key: "productAttributes1",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "DESCRIPTION2",
      prop: "description2",
      key: "description2",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "产品属性2",
      prop: "productAttributes2",
      key: "productAttributes2",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "DESCRIPTION3",
      prop: "description3",
      key: "description3",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "产品属性3",
      prop: "productAttributes3",
      key: "productAttributes3",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "DESCRIPTION4",
      prop: "description4",
      key: "description4",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "产品属性4",
      prop: "productAttributes4",
      key: "productAttributes4",
      show: true,
      disabled: false,
      show_key: "show1",
    },

    {
      label: "工艺",
      prop: "technicDesc",
      key: "technicDesc",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "technic",
      prop: "technic",
      key: "technic",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "产品信息",
      prop: "productInfoDesc",
      key: "productInfoDesc",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "productInfo",
      prop: "productInfo",
      key: "productInfo",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "车型/Car Application",
      prop: "carApplication",
      key: "carApplication",
      show: true,
      disabled: false,
      show_key: "show1",
    },

    {
      label: "产品数量",
      prop: "productQuantity",
      key: "productQuantity",
      show: true,
      disabled: false,
      type: "input",
      width: 140,
    },
    {
      label: "供应商",
      prop: "supplier",
      key: "supplier",
      show: true,
      disabled: false,
      type: "select",
      width: 140,
      remote_method: this.getTableSuppliers,
      remote: true,
      filterable: true,
      options: [],
      resetKey: { label: "abbreviation", value: "id" },
    },
    {
      label: "采购折后单价",
      prop: "purchaseDiscountUnitPrice",
      key: "purchaseDiscountUnitPrice",
      // key2: "purchaseUnitPrice",
      show: true,
      disabled: false,
      type: "price_hint",
      isEdit: true,
      width: 140,
      tooltipContent: (row) =>
        `采购计价单位:${row.purchaseQuantityStep}\n\n注意：【产品数量】必须是【采购计价单位】的倍数。\n\n因要满足产品的采购总价必须要两位小数以内。`,
    },
    {
      label: "采购单价",
      prop: "purchaseUnitPrice",
      key: "purchaseUnitPrice",
      show: true,
      disabled: false,
      width: 140,
    },
    {
      label: "采购折扣",
      prop: "purchaseDiscount",
      key: "purchaseDiscount",
      show: true,
      disabled: false,
      show_key: "show2",
      // type: "input",
      width: 140,
    },
    {
      label: "单价类型",
      prop: "unitPriceType",
      key: "unitPriceType",
      show: true,
      disabled: false,
      show_key: "show2",
      type: "select",
      options: [],
      width: 150,
      resetKey: { label: "desc", value: "id" },
    },
    {
      label: "采购总价",
      prop: "purchaseTotalPrice",
      key: "purchaseTotalPrice",
      show: true,
      disabled: false,
      width: 120,
      type: "price_warn",
      tooltipContent: "采购总价为三位小数或以上，将不能下单",
    },
    {
      label: "销售折后单价",
      prop: "saleDiscountUnitPrice",
      key: "saleDiscountUnitPrice",
      // key2: "saleUnitPrice",
      show: true,
      disabled: false,
      isEdit: true,
      width: 140,
      type: "price_hint",
      account: ['A','A_B'],
      tooltipContent: (row) =>
        `销售计价单位:${row.saleQuantityStep}\n\n注意：【产品数量】必须是【销售计价单位】的倍数。\n\n因要满足产品的销售总价必须要两位小数以内。`,
    },
    {
      label: "销售单价",
      prop: "saleUnitPrice",
      key: "saleUnitPrice",
      show: true,
      disabled: false,
      width: 140,
      account: ['A','A_B'],
    },
    {
      label: "公司定价",
      prop: "companyPrice",
      key: "companyPrice",
      show: true,
      disabled: false,
      width: 140,
      account: ['B','A_B']
    },
    {
      label: "销售折扣",
      prop: "saleDiscount",
      key: "saleDiscount",
      show: true,
      disabled: false,
      show_key: "show2",
      // type: "input",
      width: 140,
    },
    {
      label: "销售总价",
      prop: "saleTotalPrice",
      key: "saleTotalPrice",
      show: true,
      disabled: false,
      account: ['A','A_B'],
      width: 120,
      type: "price_warn",
      tooltipContent: "销售总价为三位小数或以上，将不能下单",
    },
    {
      label: "销售总定价",
      prop: "companyTotalPrice",
      key: "companyTotalPrice",
      show: true,
      disabled: false,
      account: ['B','A_B'],
      type: "price_warn",
      tooltipContent: "销售总定价为三位小数或以上，将不能下单",
    },
    {
      label: "折算利润率",
      prop: "conversionProfitMargin",
      key: "conversionProfitMargin",
      show: true,
      disabled: false,
      // type: "input",
      account: ['A','A_B'],
    },
    {
      label: "草稿记录Id",
      prop: "id",
      key: "id",
      show: false,
      disabled: false,
      show_key: "show4",
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        { name: "查看历史价格",
          code: "",
          account: ['A','A_B'],
          click: "handleHistory"
        },
        {
          name: "复制",
          code: "",
          click: "handleCopy",
          key: "isEdit",
          value: true,
        },
        {
          name: "删除",
          code: "",
          click: "handleDelete",
          type: "delete",
        },
      ],
      show: true,
      disabled: false,
      width: 260,
    },
  ] as any;

  created() {
    this.inquirySheetId = this.$route.query.id as string;
    this.listParam.inquirySheetId = this.$route.query.id as string;
    this.approvalRecordId = this.$route.query.approvalRecordId as string;
    this.listParam.code = this.$route.query.code as string;
    this.listParam.customerId = this.$route.query.customerId as string;
    this.searchForm[2].value = this.listParam.code;
    this.init();
  }

  activated() {
    this.init();
  }

  private init() {
    this.getNumberTypes();
    this.getSuppliersList();
    this.getDraftPriceType();
    this.getDraftStatus();
    this.getConversionExchangeRate();
    this.getList();
  }

  private async getDraftStatus() {
    const res: any = await getDraftStatus();
    this.draftStatus = res;
  }

  private async getNumberTypes() {
    const res: any = await getNumberTypes();
    this.searchForm[1].options = res;
  }

  private async getSuppliersList(name = "") {
    const res: any = await this.getSuppliers(name);
    this.searchForm[4].options = res;
  }

  private async getTableSuppliers(name = "") {
    const res: any = await this.getSuppliers(name);
    let index = this.tableCol.findIndex((item) => {
      return item.key === "supplier";
    });
    this.tableCol[index].options = res;
    console.log(this.tableCol[index]);
    console.log(this.tableCol[index].options);
  }

  private async getTableBrand(name = "") {
    const res: any = await this.getBrand(name);
    let index = this.tableCol.findIndex((item) => {
      return item.key === "brandName";
    });
    this.tableCol[index].options = res;
    console.log(this.tableCol[index]);
    console.log(this.tableCol[index].options);
  }

  private async getSuppliers(name = "") {
    const res: any = await getSuppliersList({ abbreviation: name });
    return res;
  }

  private async getBrand(keyworld = "") {
    const res: any = await findBrandByKeyword(this.listParam.customerId, keyworld);
    return res;
  }

  // 下载历史报价单
  public async handleHistory(scope) {
    this.selectedItem = scope.row;
    this.showHistory = true;
    // await getInquirySheetHistory(scope.row.detailId, {});
  }

  // 复制
  public async handleCopy(scope) {
    try {
      await copyQuotation(scope.row.detailInfoId);
      this.$notify({
        title: "成功",
        message: "复制成功",
        type: "success",
        duration: 2000,
      });
      this.getList();
    } catch (e) {
      this.getList();
    }
  }

  private async getDraftPriceType() {
    const res: any = await getDraftPriceType();
    res.forEach((item) => {
      item.id = item.name;
      item.name = item.desc;
    });
    this.searchForm[6].options = res;
    let index = this.tableCol.findIndex((item) => {
      return item.key === "unitPriceType";
    });
    this.tableCol[index].options = res;
    console.log("修改完成之后的tableCol", this.tableCol);
  }

  private getHiddenColumns() {
    if (
      this.$route.meta.buttonCodes &&
      Array.isArray(this.$route.meta.buttonCodes)
    ) {
      return this.$route.meta.buttonCodes.includes("actionColumns");
    }
  }

  public querySearch(data) {
    this.table.pageNumber = 1;
    this.listParam = data && data !== "reset" ? data : {};
    this.getList();
  }

  private handleFilter() {
    this.table.pageNumber = 1;
    this.getList();
  }

  public handleCommand(command) {
    this.handleDeleteMore(command);
  }

  public handleCommandEdit(command) {
    this[command]();
  }

  public changeValue(key, value) {
    console.log(key, value);
  }

  public async selectChange({ val, row, column }) {
    try {
      if (column.key === "unitPriceType") {
        let params = {
          draftId: row.row.draftId,
          type: val,
        };
        await putDraftPriceType(params); // 修改单价类型
        this.getList();
        return;
      }
      if (column.key === "brandName") {
        console.log(val);
        await updateDetailBrandName(
          row.row.detailId,
          val,
        )
        this.getList();
        return;
      }
      this.isEdit
        ? await changeQuotationSupplier({
            detailInfoId: row.row.detailInfoId,
            supplierId: val,
          })
        : await changeDraftSupplier(row.row.draftId, {
            id: row.row.draftId,
            supplierId: val,
          });
      this.getList();
    } catch (e) {
      this.$set(row.row, "supplier", "");
    }
  }

  private async getConversionExchangeRate() {
    const res: any = await getConversionExchangeRate({});
    this.conversionExchangeRate = +res.conversionExchangeRateUsd;
  }

  // 单个修改
  private async updateDraftDiscount(item, purchaseDiscount, saleDiscount) {
    const inquirySheetDetailIds = [item.detailId];
    let params = {
      inquirySheetId: this.inquirySheetId,
      inquirySheetDetailIds,
      ids: [item.draftId],
      purchaseDiscount,
      saleDiscount,
    };
    let paramsEdit = {
      ids: [item.detailInfoId],
      purchaseDiscount,
      saleDiscount,
    };
    try {
      this.isEdit
        ? await updateRecordsDiscount(paramsEdit)
        : await updateDraftDiscount(params);
      this.$notify({
        title: "提示",
        message: "修改成功",
        type: "success",
        duration: 2000,
      });
      this.getList();
    } catch {}
  }

  // 修改数量
  private async updateDraftQuantity(item, productQuantity) {
    try {
      this.isEdit
        ? await updateInquirySheetQuantity({
            detailInfoId: item.detailInfoId,
            productQuantity,
          })
        : await updateDraftQuantity(item.draftId, productQuantity);
      this.$notify({
        title: "提示",
        message: "修改成功",
        type: "success",
        duration: 2000,
      });
      this.getList();
    } catch (e) {
      this.getList();
    }
  }

  private async updateDraftBrandName(item, brandId) {
    try {
      this.isEdit
        ? await updateInquirySheetBrandName({
            detailInfoId: item.detailInfoId,
            brandId,
          })
        : await updateDetailBrandName(item.detailId, brandId);
      this.$notify({
        title: "提示",
        message: "修改成功",
        type: "success",
        duration: 2000,
      });
      this.getList();
    } catch (e) {
      this.getList();
    }
  }

  // 修改单价
  private async updateDraftUnitPrice1(item, purchasePrice, salePrice) {
    const inquirySheetDetailIds = [item.detailId];
    const ids = [item.draftId];
    let params = {
      inquirySheetId: this.inquirySheetId,
      inquirySheetDetailIds,
      ids,
      salePrice: +salePrice,
    };
    let paramsEdit = {
      saleUnitPrice: +salePrice,
    };
    try {
      this.isEdit
        ? await updateRecordsUnitPrice(item.detailInfoId, paramsEdit)
        : await updateDraftUnitPrice(params);
      this.$notify({
        title: "提示",
        message: "修改成功",
        type: "success",
        duration: 2000,
      });
      this.getList();
    } catch (e) {
      this.getList();
    }
  }
  private async updateDraftUnitPrice2(item, purchasePrice, salePrice) {
    const inquirySheetDetailIds = [item.detailId];
    const ids = [item.draftId];
    let params = {
      inquirySheetId: this.inquirySheetId,
      inquirySheetDetailIds,
      ids,
      purchasePrice: +purchasePrice,
    };
    let paramsEdit = {
      purchaseUnitPrice: +purchasePrice,
    };
    try {
      this.isEdit
        ? await updateRecordsUnitPrice(item.detailInfoId, paramsEdit)
        : await updateDraftUnitPrice(params);
      this.$notify({
        title: "提示",
        message: "修改成功",
        type: "success",
        duration: 2000,
      });
      this.getList();
    } catch (e) {
      this.getList();
    }
  }

  private async updateDraftDiscountAndProfit1(item, conversionProfitMargin) {
    const inquirySheetDetailIds = [item.detailId];
    let params = {
      inquirySheetId: this.inquirySheetId,
      inquirySheetDetailIds,
      ids: [item.draftId],
      conversionProfitMargin,
    };
    let paramsEdit = {
      ids: [item.detailInfoId],
      conversionProfitMargin,
    };

    try {
      this.isEdit
        ? await updateRecordsProfit(paramsEdit)
        : await updateDraftDiscountAndProfit(params);
      this.$notify({
        title: "提示",
        message: "修改成功",
        type: "success",
        duration: 2000,
      });
      this.getList();
    } catch (e) {
      this.getList();
    }
  }

  private calculateType = 0 as any;
  private calculateTypeNo = 0 as any;
  private accountTypeByOperation ="A";

  private handleClick(accountTypeByOperation:string) {
    this.calculateType = 0;
    this.accountTypeByOperation = accountTypeByOperation;
    this.$refs['upload']["$refs"]['upload-inner'].handleClick();
  }
  private handleClick1() {
    this.calculateType = 1;
    this.$refs['upload']["$refs"]['upload-inner'].handleClick();
  }
  private handleClick2() {
    this.calculateType = 2;
    this.$refs['upload']["$refs"]['upload-inner'].handleClick();
  }
  private handleClick3() {
    this.calculateType = 3;
    this.$refs['upload']["$refs"]['upload-inner'].handleClick();
  }

  private handleClickNo(accountTypeByOperation: string) {
    this.calculateTypeNo = 0;
    this.accountTypeByOperation = accountTypeByOperation;
    this.$refs['uploadNo']["$refs"]['upload-inner'].handleClick();
  }
  private handleClickNo1() {
    this.calculateTypeNo = 1;
    this.$refs['uploadNo']["$refs"]['upload-inner'].handleClick();
  }
  private handleClickNo2() {
    this.calculateTypeNo = 2;
    this.$refs['uploadNo']["$refs"]['upload-inner'].handleClick();
  }
  private handleClickNo3() {
    this.calculateTypeNo = 3;
    this.$refs['uploadNo']["$refs"]['upload-inner'].handleClick();
  }

  private async updateDraftDiscountAndProfit(
    item,
    purchaseUnitPrice,
    saleUnitPrice
  ) {
    const inquirySheetDetailIds = [item.detailId];
    let params = {
      inquirySheetId: this.inquirySheetId,
      inquirySheetDetailIds,
      ids: [item.draftId],
      purchaseUnitPrice,
      saleUnitPrice,
    };
    let paramsEdit = {
      ids: [item.detailInfoId],
      purchaseUnitPrice,
      saleUnitPrice,
    };

    try {
      this.isEdit
        ? await updateRecordsProfit(paramsEdit)
        : await updateDraftDiscountAndProfit(params);
      this.$notify({
        title: "提示",
        message: "修改成功",
        type: "success",
        duration: 2000,
      });
      this.getList();
    } catch (e) {
      this.getList();
    }
  }

  public async inputChange({ val, row, column }) {
    console.log(column.key);
    if (column.key === "brandName") {
      const { brandName } = row.row;
      this.updateDraftBrandName(row.row, brandName);
      this.getList();
    }
    if (column.key === "purchaseDiscount") {
      const { purchaseDiscount } = row.row;
      this.updateDraftDiscount(row.row, purchaseDiscount, null);
      this.getList();
    }
    if (column.key === "saleDiscount") {
      const { saleDiscount } = row.row;
      this.updateDraftDiscount(row.row, null, saleDiscount);
      this.getList();
    }
    if (column.key === "productQuantity") {
      const { productQuantity } = row.row;
      this.updateDraftQuantity(row.row, productQuantity);
      // this.getList();
    }
    if (column.key === "purchaseDiscountUnitPrice") {
      const { purchaseDiscountUnitPrice, saleDiscountUnitPrice } = row.row;
      this.updateDraftUnitPrice2(
        row.row,
        purchaseDiscountUnitPrice,
        saleDiscountUnitPrice
      );
      this.getList();
    }
    if (column.key === "saleDiscountUnitPrice") {
      const { purchaseDiscountUnitPrice, saleDiscountUnitPrice } = row.row;
      this.updateDraftUnitPrice1(
        row.row,
        purchaseDiscountUnitPrice,
        saleDiscountUnitPrice
      );
      // let params = {
      //   ids: [row.row.draftId],
      //   salePrice: val
      // };
      // let paramsEdit = {
      //   purchaseUnitPrice: +val
      // };
      // this.isEdit
      //   ? await updateRecordsUnitPrice(row.row.detailInfoId, paramsEdit)
      //   : await updateDraftUnitPrice(params);
      // // await updateDraftUnitPrice(params);
      this.getList();
    }
    if (column.key === "conversionProfitMargin") {
      // let conversionProfitMargin = ''
      // if(val.indexOf('%') === -1) {
      //   conversionProfitMargin = ((parseFloat(val) * 100) + '%').toString()
      // } else {
      //   conversionProfitMargin = val
      // }
      // let params = {
      //   ids: [row.row.draftId],
      //   conversionProfitMargin: val
      // };
      // await updateDraftDiscountAndProfit(params)
      // const { purchaseDiscountUnitPrice, saleDiscountUnitPrice } = row.row;
      this.updateDraftDiscountAndProfit1(row.row, val);
      this.getList();
    }
    // this.handleCalculate(row.row);
  }

  // 自动计算
  private async handleCalculate(item) {
    const purchaseDiscount = this.getDiscount(item.purchaseDiscount || 0);
    const purchaseUnitPriceWithZD = item.purchaseUnitPrice
      ? item.purchaseUnitPrice
      : 0;
    let purchaseDiscountUnitPrice = +cal.cheng(
      +cal.jian(1, purchaseDiscount),
      +purchaseUnitPriceWithZD
    );
    if (purchaseDiscountUnitPrice === 0 && purchaseUnitPriceWithZD === 0) {
      purchaseDiscountUnitPrice = null;
    } else {
      purchaseDiscountUnitPrice = purchaseDiscountUnitPrice.toFixed(2) as any;
    }
    console.log("这里走了", purchaseUnitPriceWithZD);
    this.$set(
      item,
      "purchaseDiscountUnitPrice",
      purchaseDiscountUnitPrice || null
    );
    if (purchaseDiscount === 0) {
      console.log("这里走了");
      this.$set(item, "purchaseUnitPrice", purchaseDiscountUnitPrice || 0);
    }
    // 获取采购总价
    const purchaseTotalPrice = +cal.cheng(
      purchaseDiscountUnitPrice ? purchaseDiscountUnitPrice : 0,
      item.productQuantity || 0
    );
    this.$set(item, "purchaseTotalPrice", purchaseTotalPrice);
    // saleDiscount
    const saleDiscount = this.getDiscount(item.saleDiscount);
    // saleUnitPrice
    let saleDiscountUnitPrice = +cal.cheng(
      +cal.jian(1, saleDiscount),
      item.saleUnitPrice
    );
    saleDiscountUnitPrice = saleDiscountUnitPrice.toFixed(2) as any;
    this.$set(item, "saleDiscountUnitPrice", saleDiscountUnitPrice);
    if (item.saleDiscountUnitPrice && item.productQuantity) {
      const saleTotalPrice = (
        item.saleDiscountUnitPrice * item.productQuantity
      ).toFixed(2);
      this.$set(item, "saleTotalPrice", saleTotalPrice);
    }
    // 折算利润率
    this.calculateConversionProfitMargin(item);
  }

  /**
   * 折算利润率
   */
  private calculateConversionProfitMargin(item: any) {
    const purchasePrice = item.purchaseTotalPrice;
    const salesRevenue =
      item.saleDiscountUnitPrice *
      item.productQuantity *
      this.conversionExchangeRate;
    if (
      !Number.isFinite(purchasePrice) ||
      !Number.isFinite(salesRevenue) ||
      purchasePrice <= 0
    ) {
      return null;
    }
    const profitRate = ((salesRevenue - purchasePrice) / purchasePrice).toFixed(
      2
    );
    // console.log(profitRate);
    this.$set(item, "conversionProfitMargin", profitRate);
  }

  private getDiscount(val) {
    if (val) {
      if (val.indexOf("%") === -1) {
        return val;
      }
      const discountDecimal = parseFloat(val) / 100;
      return discountDecimal;
    } else {
      return 0;
    }
  }

  private files = [] as any;
  private filesNo = [] as any;
  private addFile(file: File) {
    this.files.push(file);
  }
  private addFileNo(file: File) {
    this.filesNo.push(file);
  }


  // 下载
  public async handleDownload(accountTypeByOperation:string) {
    try {
      this.downloadPIDraft = true;
      await this.$confirm("您需要什么形式的下载", "提示", {
        confirmButtonText: "全部下载",
        cancelButtonText: "勾选下载",
        distinguishCancelAndClose: true,
        type: "success",
      })
      await downloadDraft(this.inquirySheetId,accountTypeByOperation);
    } catch (err) {
      if (err === "cancel") {
        if (this.selectedRows.length !== 0) {
          const ids = this.selectedRows.map(i => i.draftId);
          await downloadDraft(this.inquirySheetId,accountTypeByOperation,ids);
        } else {
          this.$notify({
            title: "提示",
            message: "请选择数据",
            type: "warning",
            duration: 2000,
          });
        }
      }
    }
    finally {
      this.downloadPIDraft = false;
    }
  }

  public handleExport(accountTypeByOperation:string) {
    this.isExporting = true;
    let table = this.tableCol.slice(0, this.tableCol.length - 1)
    .filter(v=> {
      // 不同账套，返回不同的字段。根据account中的字段
      if (v.account && v.account.indexOf(accountTypeByOperation) !== -1 ) {
        return v;
      }
      if (!v.account){
        return v;
      }
    });
    const headers = table.map((v) => v.label);
    const fieldNames = table.map((v) => v.key);
    let deepList = deepClone(this.selectedRows);
    deepList.map(ex => {
      if(ex.unitPriceType === 'GENERAL') {
        ex.unitPriceType = 1
      } else if(ex.unitPriceType === 'SPECIAL_CUSTOMER') {
        ex.unitPriceType = 2
      } else if(ex.unitPriceType === 'NONE') {
        ex.unitPriceType = 0
      } else {
        ex.unitPriceType = ''
      }
    })
    exportJson2Excel(
      headers,
      formatJson(fieldNames, deepList),
      `PI草稿-${new Date()}`
    );
    this.isExporting = false;
    (this.$refs.table as any).$refs.table.clearSelection();
    this.downloadPIDraft = false;
  }

  public async handleDownloadEdit(accountTypeByOperation:string) {
    try {
      this.downloadHQcomp = true;
      await this.$confirm("您需要什么形式的下载", "提示", {
        confirmButtonText: "全部下载",
        cancelButtonText: "勾选下载",
        distinguishCancelAndClose: true,
        type: "success",
      })
      await downloadQuotation(this.approvalRecordId,accountTypeByOperation)
    } catch (err) {
      if (err === "cancel") {
        if (this.selectedRows.length !== 0) {
          const ids = this.selectedRows.map(i => i.detailInfoId);
          await downloadQuotation(this.approvalRecordId, accountTypeByOperation, ids)
        } else {
          this.$notify({
            title: "提示",
            message: "请选择数据",
            type: "warning",
            duration: 2000,
          });
        }
      }
    } finally {
      this.downloadHQcomp = false;
    }
  }

  // 上传维护
  private async handleUpload(file: any) {
    console.log(file);
    this.allUpdate = true;
    let formData = new FormData();
    formData.append("inquiryId", this.inquirySheetId);
    formData.append("file", file.file);
    await uploadPiDraft(formData).then(async res => {
      this.allUpdate = false;
        this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000
      });
      await this.getList();
    }).catch(err => {
      this.allUpdate = false;
    });
  }

  // 上传维护
  private async handleUploadEdit(file: any) {
    // console.log(file);
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    this.allUpdateEdit = true
    let formData = new FormData();
    formData.append("inquiryId", this.inquirySheetId);
    formData.append("file", file.file);
    // formData.append("calculateType", this.calculateType);
    formData.append("calculateType", "3");
    formData.append("accountTypeByOperation", this.accountTypeByOperation);
    await uploadInquiryApprovalRecord(formData).then(async res=> {
      this.allUpdateEdit = false;
      await this.getList();
      loading.close();
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000
      });
    }).catch(err=> {
      this.allUpdateEdit = false;
      this.getList();
      loading.close();
    });
  }

  private async handleUploadEditNo(file: any) {
    // console.log(file);
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    this.allUpdateEditNo = true
    let formData = new FormData();
    formData.append("inquiryId", this.inquirySheetId);
    formData.append("file", file.file);
    // formData.append("calculateType", this.calculateTypeNo);
    formData.append("calculateType", "3");
    formData.append("accountTypeByOperation", this.accountTypeByOperation);
    await uploadPiDraft(formData).then(async res=> {
      this.allUpdateEditNo = false;
      await this.getList();
      loading.close();
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000
      });
    }).catch(err=> {
      this.allUpdateEditNo = false;
      this.getList();
      loading.close();
    });
  }

  private handleModify() {
    if (!this.selectedRows.length) {
      this.$notify({
        title: "提示",
        message: "请选择产品",
        type: "error",
        duration: 2000,
      });
      return;
    }
    this.showModify = true;
  }

  private handleRate() {
    if (!this.selectedRows.length) {
      this.$notify({
        title: "提示",
        message: "请选择产品",
        type: "error",
        duration: 2000,
      });
      return;
    }
    this.showRate = true;
  }

  private handleSuccess() {
    this.showRate = false;
    this.showHistory = false;
    this.showModify = false;
    this.selectedRows = [];
    (this.$refs.table as any).$refs.table.clearSelection();
    this.getList();
  }

  // 保存报价
  private async saveInquirySheet() {
    this.saveBaoJiaLoading = true;
    await saveInquirySheet(this.inquirySheetId)
      .then((res) => {
        this.saveBaoJiaLoading = false;
      })
      .catch((err) => {
        this.saveBaoJiaLoading = false;
      });
    this.$notify({
      title: "成功",
      message: "保存报价成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  // 提交审批
  private async submitDraft() {
    this.saveSubmitLoading = true;
    // await this.saveInquirySheet();
    if (!this.selectedRows.length) {
      this.$notify({
        title: "提示",
        message: "请选择产品",
        type: "error",
        duration: 2000,
      });
      this.saveSubmitLoading = false;
      return;
    }
    this.$confirm(`您将要提交${this.selectedRows.length}个产品进行审核`, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
    .then(async () => {
      const inquirySheetDetailIds = this.selectedRows.map(
        (item) => item.detailId
      );
      const ids = this.selectedRows.map((item) => item.draftId);
      let params = {
        inquirySheetId: this.inquirySheetId,
        inquirySheetDetailIds,
        ids
      };
      try {
        const res: any = await submitDraft(params);
        this.saveSubmitLoading = false;
        this.$notify({
          title: "成功",
          message: "提交审批成功",
          type: "success",
          duration: 2000,
        });
        (this.$refs.table as any).$refs.table.clearSelection();
        this.$router.push(
          `/quotationAudit`
        );
      } catch {
        this.saveSubmitLoading = false;
      }
    })
    .catch((err) => {
      this.saveSubmitLoading = false;
      console.error(err);
    });
  }
  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    const params = {
      ...this.listParam,
      inquirySheetId: this.inquirySheetId,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    const paramsEdit = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
      approvalRecordId: this.approvalRecordId,
    };
    delete paramsEdit.inquirySheetId;
    // 判断this.listParam中是否包含quotedStatus
    if (this.listParam.quotedStatus) {
      params.quotedStatus = this.listParam.quotedStatus;
    } else {
      params.quotedStatus = null;
    }
    this.listLoading = false;
    let { total, list }: any = this.isEdit
      ? await getEditSearch(paramsEdit)
      : await getDraftList(params);
    list.forEach((item) => {
      item.isEdit = this.isEdit;
      item.purchaseQuantityStep = calcQuantityStep(item.purchaseDiscountUnitPrice);
      item.saleQuantityStep = calcQuantityStep(item.saleDiscountUnitPrice);
    });
    this.table.total = +total;
    this.table.list = list;
    // this.table.list.forEach((item) => {
    //   this.handleCalculate(item);
    // });
    this.loading = false;
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }

  //  删除
  public async handleDelete(scope) {
    let params = {
      piIds: [scope.row.draftId || scope.row.id],
    };
    const paramsEdit = `ids=${scope.row.detailInfoId}`;
    await this.removeProducts(params, paramsEdit);
  }

  private handleDeleteMore(condition) {
    if (!this.selectedRows.length && condition === "delete") {
      this.$message.error("请选择产品");
      return;
    }
    this.$confirm("移除后不可恢复，确定要移除吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        const piIds = this.selectedRows.map((item) =>
          this.isEdit ? item.detailInfoId : item.draftId
        );
        let params = {
          piIds: condition === "delete" ? piIds : [],
          condition: condition === "delete" ? "" : condition,
        };
        const ids = this.selectedRows.map((item) => item.detailInfoId);
        const paramsEdit = ids.map((id) => `ids=${id}`).join("&");
        this.removeProducts(params, paramsEdit);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private async removeProducts(params, paramsEdit) {
    this.isEdit
      ? await removeRecordsProduct(paramsEdit)
      : await removeInquirySheetPIProduct(params);

    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    this.handleSuccess();
  }

  // 点击是否展示所有产品号码
  private showMore() {
    this.isShowMore = !this.isShowMore;
  }

  private showMore2() {
    this.isShowMore2 = !this.isShowMore2;
  }

  private showMore3() {
    this.isShowMore3 = !this.isShowMore3;
  }

  //删除柜型
  private removeContainerType(idx: number) {
    this.configuredContainerTypes = this.configuredContainerTypes.filter(
      (value, index) => index != idx
    );
  }

  private selectedRows: DraftModel[] = [];

  private onSelectionChange(rows: DraftModel[]) {
    this.selectedRows = rows;
  }

  private  getCurrentAccountType():string {
   return  UserModule.accountType[0];
  }
}
